export const version = "logger/5.6.0";
//# sourceMappingURL=_version.js.map